import Tagify from '@yaireo/tagify';
import '@yaireo/tagify/dist/tagify.css';

export function initOrderLabels() {
  const input = document.querySelector('[data-order-labels]');
  if (!input) return;

  const basePath = window.location.pathname;
  const initialTags = input.value ? input.value.split(',').map(t => t.trim()).filter(Boolean) : [];
  input.value = '';

  const tagify = new Tagify(input);

  let reverting = false;
  let initialized = false;

  function postTag(path, name) {
    return $.ajax({ url: `${basePath}/${path}`, method: 'POST', data: { name }, dataType: 'text' });
  }

  tagify.on('add', (e) => {
    if (!initialized || reverting) return;
    const tag = e.detail.data.value;
    postTag('add_owned_tag', tag).fail(() => {
      reverting = true;
      tagify.removeTags([e.detail.tag]);
      reverting = false;
    });
  });

  tagify.on('remove', (e) => {
    if (!initialized || reverting) return;
    const tag = e.detail.data.value;
    postTag('remove_owned_tag', tag).fail(() => {
      reverting = true;
      tagify.addTags([tag]);
      reverting = false;
    });
  });

  if (initialTags.length) tagify.addTags(initialTags);
  initialized = true;
}

document.addEventListener('DOMContentLoaded', initOrderLabels);
